// Tiny analytics dispatcher. Real providers (GA4, Segment, PostHog) plug
// in by replacing the `sink` via setAnalyticsSink(). Default sink logs in
// dev and no-ops in prod so we never silently send PII.
let sink = (event, props) => {
  if (import.meta.env.DEV) {
    console.debug('[analytics]', event, props ?? {});
  }
};

export function setAnalyticsSink(fn) {
  if (typeof fn === 'function') sink = fn;
}

/**
 * @param {string} event   stable name, e.g. "cart_add", "checkout_complete"
 * @param {object} [props]
 */
export function track(event, props) {
  try {
    sink(event, props);
  } catch (err) {
    if (import.meta.env.DEV) console.warn('analytics sink threw', err);
  }
}

/** Convenience for page-view events. */
export function trackPageView(pathname, props) {
  track('page_view', { path: pathname, ...props });
}
